export const createCopy = (param) => {
  if (param === undefined) return undefined;

  const result = JSON.parse(JSON.stringify(param));

  return result;
};
